import React from 'react';
import LegalLayout from './legallayout';
import { Helmet } from 'react-helmet-async';

const Privacy = () => (
  <LegalLayout title="Privacy Policy" lastUpdated="April 3, 2026">
    <Helmet>
        <title>Privacy Policy | Sitemanifest</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    <section>
      <h2 className="text-xl font-bold text-black mb-4">1. Information We Collect</h2>
      <p>
        Sitemanifest collects information necessary to provide our Reputation Firewall services. 
        This includes:
      </p>
      <ul className="list-disc ml-6 space-y-2">
        <li><strong>Account Data:</strong> Business name, email address, and billing information.</li>
        <li><strong>Verification Media:</strong> Screenshots or images uploaded by Business Users or Guest Reviewers to prove "Proof of Service."</li>
        <li><strong>Invitation Data:</strong> Email addresses provided by Business Users to invite customers to leave a review.</li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">2. How We Use Your Data</h2>
      <p>
        Your data is used to verify the authenticity of reviews and to host your Business Profile 
        on our Registry. We do not sell, trade, or rent your personal information to third-party 
        marketers. Reviewer data is used strictly for verification and is never shared with 
        unauthorized third parties.
      </p>
    </section>
    
<section>
  <h2 className="text-xl font-bold text-black mb-4">3. Data Isolation and Security</h2>
  <p className="mb-4">
    Sitemanifest employs a <strong>Zero-Cross-Pollination</strong> architecture. Using Row Level Security (RLS), all Invitation Data and Verification Media are cryptographically siloed to the specific Business account that uploaded them. 
  </p>
  <ul className="list-disc ml-6 space-y-2">
    <li><strong>Verification Proofs:</strong> Screenshots or images are used solely for moderation. They are never displayed publicly and are <strong>permanently deleted</strong> immediately after a review is moderated.</li>
    <li><strong>Invitation Privacy:</strong> Customer email addresses uploaded for invitations are accessible only to the uploader and our automated delivery system. We do not use this data for our own marketing or share it with other businesses.</li>
  </ul>
</section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">4. Third-Party Service Providers</h2>
      <p>To provide our service, we share limited data with the following processors:</p>
      <ul className="list-disc ml-6 space-y-2">
        <li><strong>Paddle:</strong> Our Merchant of Record for secure payment and tax processing.</li>
        <li><strong>Vercel:</strong> For website hosting and performance.</li>
        <li><strong>Resend/Postmark:</strong> For delivering verified review invitations via email.</li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">5. Cookies and Tracking</h2>
      <p>
        We use essential cookies to maintain your login session and ensure the security of 
        your dashboard. Our payment processor, <strong>Paddle</strong>, also utilizes 
        functional cookies to ensure secure transaction processing and fraud prevention. 
        We do not use tracking cookies for advertising purposes.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">6. Your Rights (GDPR & Global Standards)</h2>
      <p>
        Regardless of your location, Sitemanifest provides you the right to access, correct, 
        or delete your personal data. To exercise these rights, please contact our data 
        privacy team at <span className="text-[#3EBAA2] font-semibold">support@sitemanifest.com</span>.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-bold text-black mb-4">7. Changes to This Policy</h2>
      <p>
        We may update this policy periodically to reflect changes in our service or legal 
        requirements. Significant changes will be notified to Business Users via the email 
        associated with their account.
      </p>
    </section>
    <section>
      <h2 className="text-xl font-bold text-black mb-4">8. Consent and Proof Handling</h2>
      <p>
      Verification proofs (such as screenshots or images) are collected solely for the purpose of moderating and validating reviews. These proofs are never displayed publicly and are permanently deleted immediately after a review is accepted or declined. By submitting a proof, Business Users confirm that their customers have consented to its use for verification. Sitemanifest retains only non-identifiable metadata confirming that a proof was submitted and verified, for compliance and audit purposes..      </p>
    </section>
  </LegalLayout>
);

export default Privacy;